import TagIcon from "assets/icons/tagIcon";
import TextWithTooltip from "views/components/TextWithTooltip";
import styles from "./style.module.scss";

interface ClassTagProps {
  value: string;
}

export default function ClassTag({ value }: ClassTagProps) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.tagIcon} data-testid="class-tag-icon">
        <TagIcon />
      </div>
      <TextWithTooltip text={value} fontSize={16} />
    </div>
  );
}
